module.exports = __webpack_public_path__ + "static/media/long_description_icon.0d9f43f6.svg";